import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import jwt_decode from 'jwt-decode';
import paidStamp from '../../images/icon/paid.png';
import Moment from 'react-moment';
import { setBluetoothStatus, setPrintInvoice } from '../../../features/Data/dataSlice';
import { setOpticPrintBill } from '../../../features/Offcanvas/customOrderDetailModalSlice';
import Logo from '../../images/logo.svg'
import ShreeOptics from '../../images/logos/shree-optics.png'
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { setPairedDeviceArr, setDefaultPrinterName } from '../../../features/Data/dataSlice';
import { showPrinterSettingModal } from '../../../features/Offcanvas/printerSettingModalSlice';

const CustomPrintBill = ({
    invoiceWithOrders,
    opticPrintBill,
    opticPrintBillData,
    setOpticPrintBill,
    businessData,
    authToken,
    printType,
    setPairedDeviceArr,
    bluetoothStatus,
    buildType,
    defaultPrinterName,
    showPrinterSettingModal,
    setDefaultPrinterName
}) => {
    const [branchData, setBranchData] = useState(null)
    const [businessTempData, setBusinessTempData] = useState(null)
    const tempDefaultPrinterName = localStorage.getItem('defaultPrinterName')
    useEffect(() => {
        if (tempDefaultPrinterName) {
            setDefaultPrinterName({defaultPrinterName: tempDefaultPrinterName})
        }
    }, [tempDefaultPrinterName])
    useEffect(() => {
        const tokenData = jwt_decode(authToken)
        if (businessData) {
          businessData.map((value, key) => {
            value.Branches.map((v,k) => {
                if (value.ID === tokenData.userInfo.Business_ID && v.ID === tokenData.userInfo.DefaultLocationID) {
                    setBranchData(v)
                    setBusinessTempData(value)
                }
            })
          }) 
        }
    }, [businessData, authToken])
    let PrintInvoiceReceipt = ''
    function printCustomBillIframe(billData) {
        var iframe = document.getElementById('myIframe');
        let tr1 = ''
        opticPrintBillData?.Items.map((v, k) => {
            let tdData = ''
            if (v.CustomSIze) {
                tdData = `<tr> 
                        <td style="padding: 8px;border: solid 2px #333333;">${k + 1}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;">${v.CustomSIze}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;"></td> 
                        <td style="padding: 8px;border: solid 2px #333333; text-align: center;">${v.MRP}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${v.quantity}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${parseInt(v.quantity) * v.MRP}</td> 
                    </tr>`
            }
            tr1 += tdData
        });

        PrintInvoiceReceipt = '<div style="display: flex;flex-flow: column;"> <div style="width: 100%; border: solid 2px #333333; display: flex;"> <div style="width: 20%;display: flex; justify-content: center; align-items: center;border-right: solid 2px #333333;"> <img src=' + Logo + ' width="110px" /> </div> <div style="width: 60%;border-right: solid 2px #333333;"> <h2 style="text-align: center; margin-bottom: 0px; margin-top: 10px;">Composition Taxable Person</h2> <h2 style="text-align: center; margin-top: 3px;">Bill Of Supply</h2> <h4 style="text-align: center; font-weight: normal;">Shop No. 3, Shree Namrata, Plot No. 1354 A/2 Chatrapati Shivaji Maharaj Marg. Panvel - 410206 <br />Tel: 2748 0850 Mob: 9819244417</h4> <h4 style="text-align: center; font-weight: normal; margin-bottom: 10px; margin-top: 10px;">GST NO: <b>27AOIPK6558BIZV</b></h4> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <img src=' + ShreeOptics + ' width="110px" /> </div> </div> <div style="width: 100%; border: solid 2px #333333; border-top: none; display: flex;"> <div style="width: 20%; display: flex; justify-content: center; align-items: center; border-right: solid 2px #333333;"> <h4 style="text-align: center;margin: 3px;">Invoice No: ' + opticPrintBillData?.BillNo + '</h4> </div> <div style="width: 60%;border-right: solid 2px #333333;display: flex; align-items: center;justify-content: center;"> <h3 style="text-align: center;margin: 3px;">Name:' + opticPrintBillData?.Name + '</h3> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <h4 style="text-align: center;margin: 3px;">Date:' + moment(opticPrintBillData?.OrderDate).format("DD/MM/YYYY") + '</h4> </div> </div> </div> <div style="margin-top: 30px;"><table style="border-collapse: collapse;width: 100%;"> <tr> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">No</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Particulars</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Challan No.</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Rate</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Quantity</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Amount</th> </tr>' + tr1 + '<tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Total</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">' + opticPrintBillData.GrandTotal + ' </td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Discount</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">' + opticPrintBillData.TotalDiscount + '</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Advance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">' + opticPrintBillData.TotalPaidAmount + '</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Balance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">' + (opticPrintBillData.GrandTotal - opticPrintBillData.TotalPaidAmount) + '</td> </tr> </table></div>'
        
        iframe.contentWindow.document.body.innerHTML = PrintInvoiceReceipt


        if (buildType == 'webapk') {
            iframe.onload = function() {
                iframe.contentWindow.print();
            };
    
            if (iframe.contentDocument.readyState === 'complete') {
                iframe.contentWindow.print();
            }
        } else {
            let checkPrinterConnection = null
            
            var plainText = extractTextFromHTML(PrintInvoiceReceipt);
            if (bluetoothStatus && defaultPrinterName) {
                window.BTPrinter.connect(function(data){
                    console.log("Connect Success", data);
                    window.BTPrinter.printTextSizeAlign(function(data1){
                        console.log("printTextSizeAlign Success", data1);
                        window.BTPrinter.disconnect(function(data){
                            console.log("Success");
                            console.log(data)
                        },function(err){
                            console.log("Error");
                            console.log(err)
                        }, defaultPrinterName);
                    },function(err){
                        window.BTPrinter.disconnect(function(data){
                            console.log("Success");
                            console.log(data)
                        },function(err){
                            console.log("Error");
                            console.log(err)
                        }, defaultPrinterName);
                        console.log("Error");
                        console.log(err)
                    }, plainText,'0','0')
                },function(err){
                    console.log("Error");
                    console.log(err)
                    setDefaultPrinterName({defaultPrinterName: null})
                    // localStorage.removeItem('defaultPrinterName')
                    showPrinterSettingModal({printerSettingModalVisible: true})
                }, defaultPrinterName);
            } else {
                if (!bluetoothStatus) {
                    alert('Your bluetooth is off')
                } else if (bluetoothStatus && (!defaultPrinterName)) {
                    showPrinterSettingModal({printerSettingModalVisible: true})
                }
            }
        }

    }

    // function extractTextFromHTML(htmlString) {
    //     // Create a temporary DOM element
    //     var tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = htmlString;
      
    //     // Find the table
    //     var table = tempDiv.querySelector('table');
    //     if (!table) {
    //       console.error('No table found in the HTML string');
    //       return '';
    //     }
      
    //     // Extract table data row by row
    //     var rows = table.rows;
    //     var output = '';
      
    //     for (var i = 0; i < rows.length; i++) {
    //       var cells = rows[i].cells;
    //       for (var j = 0; j < cells.length; j++) {
    //         output += cells[j].textContent.trim() + '\t'; // Use tab for spacing between columns
    //       }
    //       output += '\n'; // New line for each row
    //     }
      
    //     return output;
    // }

    function extractTextFromHTML(htmlString) {
        // Create a temporary DOM element
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
    
        // Extract all text content
        var output = '';
    
        // Extract business name, branch name, and invoice details
        var businessName = tempDiv.querySelector('#receiptDetails > div:nth-child(2)');
        var branchName = tempDiv.querySelector('#receiptDetails > div:nth-child(3)');
        var billNo = tempDiv.querySelector('#receiptDetails > div:nth-child(4)');
        var orderType = tempDiv.querySelector('#receiptDetails > div:nth-child(5)');
        var orderDate = tempDiv.querySelector('#receiptDetails > div:nth-child(6)');
    
        output += (businessName ? businessName.textContent.trim() : '') + '\n';
        output += (branchName ? branchName.textContent.trim() : '') + '\n';
        output += (billNo ? billNo.textContent.trim() : '') + '\n';
        output += (orderType ? orderType.textContent.trim() : '') + '\n';
        output += (orderDate ? orderDate.textContent.trim() : '') + '\n\n';
    
        // Find the table and extract data
        var table = tempDiv.querySelector('table');
        if (table) {
            var rows = table.rows;
            for (var i = 0; i < rows.length; i++) {
                var cells = rows[i].cells;
                for (var j = 0; j < cells.length; j++) {
                    output += cells[j].textContent.trim() + '\t'; // Use tab for spacing between columns
                }
                output += '\n'; // New line for each row
            }
            output += '\n'; // Extra line break after the table
        } else {
            console.error('No table found in the HTML string');
        }
    
        // Extract subtotal, discount, tax, grand total from the table below
        var rows = tempDiv.querySelectorAll('tr'); // Get all table rows
        rows.forEach(function (row) {
            var cells = row.cells;
            if (cells.length === 2) {
                var label = cells[0].textContent.trim();
                var value = cells[1].textContent.trim();
                if (label === 'Subtotal') {
                    output += 'Subtotal: ' + value + '\n';
                } else if (label.startsWith('Discount')) {
                    output += label + ': ' + value + '\n'; // Handles 'Discount (X%)'
                } else if (label === 'Grand Total') {
                    output += 'Grand Total: ' + value + '\n';
                }
            }
        });
    
        // Extract footer message
        var footer = tempDiv.querySelector('div[style*="text-align: center"]');
        output += '\n' + (footer ? footer.textContent.trim() : '') + '\n';
    
        return output;
    }
    
    const generateAndShareImage = async (data, type) => {
        try {
            let tr1 = ''
            opticPrintBillData?.Items.map((v, k) => {
                let tdData = ''
                if (v.CustomSIze) {
                    tdData = `<tr> 
                            <td style="padding: 8px;border: solid 2px #333333;">${k + 1}</td> 
                            <td style="padding: 8px;border: solid 2px #333333;">${v.CustomSIze}</td> 
                            <td style="padding: 8px;border: solid 2px #333333;"></td> 
                            <td style="padding: 8px;border: solid 2px #333333; text-align: center;">${v.MRP}</td> 
                            <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${v.quantity}</td> 
                            <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${parseInt(v.quantity) * v.MRP}</td> 
                        </tr>`
                }
                tr1 += tdData
            });
          // Define the HTML content as a string
          const htmlContent = `<div style="display: flex;flex-flow: column;padding: 25px;"> <div style="width: 100%; border: solid 2px #333333; display: flex;"> <div style="width: 20%;display: flex; justify-content: center; align-items: center;border-right: solid 2px #333333;"> <img src="${Logo}" width="110px" /> </div> <div style="width: 60%;border-right: solid 2px #333333;"> <h2 style="text-align: center; margin-bottom: 0px; margin-top: 10px;">Composition Taxable Person</h2> <h2 style="text-align: center; margin-top: 3px;">Bill Of Supply</h2> <h4 style="text-align: center; font-weight: normal;">Shop No. 3, Shree Namrata, Plot No. 1354 A/2 Chatrapati Shivaji Maharaj Marg. Panvel - 410206 <br />Tel: 2748 0850 Mob: 9819244417</h4> <h4 style="text-align: center; font-weight: normal; margin-bottom: 10px; margin-top: 10px;">GST NO: <b>27AOIPK6558BIZV</b></h4> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <img src="${ShreeOptics}" width="110px" /> </div> </div> <div style="width: 100%; border: solid 2px #333333; border-top: none; display: flex;"> <div style="width: 20%; display: flex; justify-content: center; align-items: center; border-right: solid 2px #333333;"> <h4 style="text-align: center;margin: 3px;">Invoice No: ${opticPrintBillData?.BillNo}</h4> </div> <div style="width: 60%;border-right: solid 2px #333333;display: flex; align-items: center;justify-content: center;"> <h3 style="text-align: center;margin: 3px;">Name: ${opticPrintBillData?.Name}</h3> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <h4 style="text-align: center;margin: 3px;">Date: ${moment(opticPrintBillData?.OrderDate).format("DD/MM/YYYY")}</h4> </div> </div> </div> <div style="margin-top: 30px;padding: 25px;"> <table style="border-collapse: collapse;width: 100%;"> <tr> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">No</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Particulars</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Challan No.</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Rate</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Quantity</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Amount</th> </tr>${tr1}<tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Total</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.GrandTotal} </td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Discount</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.TotalDiscount}</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Advance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.TotalPaidAmount}</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Balance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${(opticPrintBillData.GrandTotal - opticPrintBillData.TotalPaidAmount)}</td> </tr> </table> </div>`;
    
        //   const tempDiv = document.createElement('div');
        //   tempDiv.innerHTML = htmlContent;
        //   document.body.appendChild(tempDiv);
    
        //     const canvas = await html2canvas(tempDiv);
        //     const imgData = canvas.toDataURL('image/png');

            let container = document.createElement('div');
            container.innerHTML = htmlContent;
            document.body.appendChild(container); // Add to DOM temporarily

            // Use html2canvas to convert the container to an image
            html2canvas(container).then(function (canvas) {
                let imageData = canvas.toDataURL("image/png"); // Convert canvas to image data URL
                if (type == 'image') {
                    shareImage(imageData, 'image'); // Call the sharing function
                    setOpticPrintBill({opticPrintBill: false, opticPrintBillData: null, printType: ''})
                } else if (type == 'whatsappImage') {
                    shareImage(imageData, 'whatsappImage');
                    setOpticPrintBill({opticPrintBill: false, opticPrintBillData: null, printType: ''})
                }
                document.body.removeChild(container); // Remove the container from DOM after capture
            });

          // Convert image data to Blob
        //   const imgBlob = await (await fetch(imgData)).blob();
        //   console.log(imgBlob)
          // Clean up the temporary div
        //   document.body.removeChild(tempDiv);
        //   Check if the Web Share API is available
        //   if (navigator.canShare && navigator.canShare({ files: [new File([imgBlob], 'image.png', { type: 'image/png' })] })) {
        //     // Use File API for sharing the image
        //     navigator.share({
        //       title: 'Check out this image!',
        //       files: [new File([imgBlob], 'image.png', { type: 'image/png' })]
        //     })
        //     .then(() => console.log('Successful share'))
        //     .catch((error) => console.log('Error sharing:', error));
        //   } else {
        //     console.log('Web Share API not supported or cannot share files');
        //   }
        } catch (error) {
          console.error('Error generating or sharing image:', error);
        }
    };

    const shareImage = async (imageUrl, type) => {
        console.log(imageUrl)
        if (type == 'image') {
            window.plugins.socialsharing.share(null, null, imageUrl, null)
        } 
    }

    const handleGenerateAndSharePDF = async () => {
        let tr1 = ''
        opticPrintBillData?.Items.map((v, k) => {
            let tdData = ''
            if (v.CustomSIze) {
                tdData = `<tr> 
                        <td style="padding: 8px;border: solid 2px #333333;">${k + 1}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;">${v.CustomSIze}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;"></td> 
                        <td style="padding: 8px;border: solid 2px #333333; text-align: center;">${v.MRP}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${v.quantity}</td> 
                        <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${parseInt(v.quantity) * v.MRP}</td> 
                    </tr>`
            }
            tr1 += tdData
        });
        const element = `<div style="display: flex;flex-flow: column;"> <div style="width: 100%; border: solid 2px #333333; display: flex;"> <div style="width: 20%;display: flex; justify-content: center; align-items: center;border-right: solid 2px #333333;"> <img src="${Logo}" width="110px" /> </div> <div style="width: 60%;border-right: solid 2px #333333;"> <h3 style="text-align: center; margin-bottom: 0px; margin-top: 10px;">Composition Taxable Person</h3> <h3 style="text-align: center; margin-top: 3px;">Bill Of Supply</h3> <h5 style="text-align: center; font-weight: normal;">Shop No. 3, Shree Namrata, Plot No. 1354 A/2 Chatrapati Shivaji Maharaj Marg. Panvel - 410206 <br />Tel: 2748 0850 Mob: 9819244417</h5> <h5 style="text-align: center; font-weight: normal; margin-bottom: 10px; margin-top: 10px;">GST NO: <b>27AOIPK6558BIZV</b></h5> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <img src="${ShreeOptics}" width="110px" /> </div> </div> <div style="width: 100%; border: solid 2px #333333; border-top: none; display: flex;"> <div style="width: 20%; display: flex; justify-content: center; align-items: center; border-right: solid 2px #333333;"> <h5 style="text-align: center;margin: 3px;font-weight: bold !important;">Invoice No: ${opticPrintBillData?.BillNo}</h5> </div> <div style="width: 60%;border-right: solid 2px #333333;display: flex; align-items: center;justify-content: center;"> <h4 style="text-align: center;margin: 3px;font-weight: bold !important;">Name: ${opticPrintBillData?.Name}</h4> </div> <div style="width: 20%;display: flex; justify-content: center; align-items: center;"> <h5 style="text-align: center;margin: 3px;font-weight: bold !important;">Date: ${moment(opticPrintBillData?.OrderDate).format("DD/MM/YYYY")}</h5> </div> </div> </div> <div style="margin-top: 30px;"> 
        <table style="border-collapse: collapse;width: 100%;"> <tr> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">No</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Particulars</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Challan No.</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Rate</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Quantity</th> <th style="padding: 8px;border: solid 2px #333333;font-size: 20px;">Amount</th> </tr>${tr1}<tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Total</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.GrandTotal} </td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Discount</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.TotalDiscount}</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Advance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${opticPrintBillData.TotalPaidAmount}</td> </tr> <tr> <td style="padding: 8px;border: solid 2px #333333;" colspan="5">Balance</td> <td style="padding: 8px;border: solid 2px #333333;text-align: right;">${(opticPrintBillData.GrandTotal - opticPrintBillData.TotalPaidAmount)}</td> </tr> </table> </div>`;
    
        // Convert the HTML content to a PDF and get the output as a Blob
        const opt = {
          margin: 1,
          filename: 'document.pdf',
          html2canvas: { scale: 1 },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        };

        // var fileURL = 'https://webweb.ams3.cdn.digitaloceanspaces.com/data/suryadattadev.webweb.ai/lifetime-fellow-achivement.jpg'; // Update this path to the location of your PDF
        // var message = 'Check out this PDF!';
        // var subject = 'PDF Sharing';

        // // Use the social sharing plugin to share the PDF
        // window.plugins.socialsharing.shareViaWhatsApp(
        //     message, // Message to send
        //     null,    // Image (if any)
        //     fileURL, // File URL
        //     null,    // URL to share
        //     subject  // Subject (for email)
        // );
    
        try {
          // Generate the PDF and get the Blob
          const pdfBlob = await html2pdf().from(element).set(opt).outputPdf('blob');
    
          // Create a File object from the Blob
          const pdfFile = new File([pdfBlob], 'document.pdf', { type: 'application/pdf' });
    
          // Check if the browser supports the navigator.share API with files
          if (navigator.canShare && navigator.canShare({ files: [pdfFile] })) {
            await navigator.share({
              title: 'Document',
              files: [pdfFile],
            });
            console.log('PDF shared successfully!');
          } else {
            console.log('Sharing not supported on this browser.');
          }
        } catch (error) {
          console.error('Error generating or sharing PDF:', error);
        }
    };

    useEffect(() => {
        if (opticPrintBill == true) {
            console.log(printType)
            if (printType == 'image') {
                generateAndShareImage(opticPrintBillData, 'image')
            } else if (printType == 'whatsappImage') {
                generateAndShareImage(opticPrintBillData, 'whatsappImage')
            } else if (printType == 'pdf') {
                // generateAndSharePdf(opticPrintBillData)
                handleGenerateAndSharePDF(opticPrintBillData)
            } else {
                printCustomBillIframe(opticPrintBillData)
                setOpticPrintBill({opticPrintBill: false, opticPrintBillData: opticPrintBillData})
            }
        }
    }, [opticPrintBill, printType])
    return (
        <iframe id="myIframe" style={{display: 'none'}}></iframe> 
    );
};

const mapStateToProps = ({ data, auth, customOrderDetail }) => {
    const {
        paymentStatus,
        printInvoice,
        businessData,
        bluetoothStatus,
        defaultPrinterName
    } = data
    const {
        authToken,
        buildType
    } = auth
    const {
        opticPrintBill,
        opticPrintBillData,
        printType
    } = customOrderDetail
    return {
        paymentStatus,
        printInvoice,
        opticPrintBill,
        opticPrintBillData,
        businessData,
        authToken,
        printType,
        bluetoothStatus,
        buildType,
        defaultPrinterName
    }
}
  
const mapDispatchToProps = {
    setPrintInvoice,
    setOpticPrintBill,
    setPairedDeviceArr,
    showPrinterSettingModal,
    setDefaultPrinterName
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomPrintBill);